/* ============================================================
 * Inquire Handoff — Anfrage-Link → Kontaktformular
 *
 * Ein delegierter Klick-Listener für jeden Link mit
 * `data-inquire-link`. Er legt den Nachrichtentext unter
 * sessionStorage["contact-prefill"] ab; `assets/contact-tabs.js`
 * liest ihn auf der Kontaktseite, schreibt ihn in
 * `contact[body]` und löscht den Eintrag danach. Über Shopifys
 * `{% form 'contact' %}` landet der Text damit in der
 * Kontaktformular-Mail.
 *
 * Warum sessionStorage und nicht ein Query-Parameter: Liquid
 * kann Query-Parameter nicht lesen (Shopifys `request`-Objekt
 * hat keinen Query-String), der Wert müsste also ohnehin per JS
 * in ein Hidden-Feld wandern. Denselben Weg nutzt der
 * Preisrechner schon über `pcw-kalkulation`.
 *
 * Attribute am Link:
 *   data-inquire-link           Pflicht, markiert den Link.
 *   data-prefill-message        Fertige Nachricht (Rückfall).
 *   data-prefill-base           Nachricht ohne Variantenteil.
 *   data-prefill-variant-label  Trenntext vor der Variante.
 *   data-prefill-customer-type  Optional "business" → passenden
 *                               Tab auf der Kontaktseite wählen.
 *
 * Sind `base` und `variant-label` gesetzt, wird die Nachricht
 * beim Klick aus dem Variant-Picker neu gebaut. Nötig, weil ein
 * Variantenwechsel nur `<variant-picker>` morpht und das
 * serverseitig gerenderte Markup des Links unberührt lässt.
 * ============================================================ */

(function () {
  'use strict';

  const STORAGE_KEY = 'contact-prefill';
  const BOUND_FLAG = '__inquireHandoffBound';

  // Liegt die Section zweimal auf einer Seite, wird das Tag auch zweimal
  // ausgeführt. Der Listener ist delegiert und global — einmal reicht.
  if (/** @type {any} */ (window)[BOUND_FLAG]) return;
  /** @type {any} */ (window)[BOUND_FLAG] = true;

  /**
   * Options-Werte der aktuell gewählten Variante aus dem Picker lesen.
   * querySelectorAll behält die DOM-Reihenfolge, deshalb entsteht dieselbe
   * Reihenfolge, die Shopify auch für `variant.title` verwendet. Deckt den
   * Button-/Swatch-Stil (Radios) und den Dropdown-Stil (Selects) ab.
   * @param {Element} link
   * @returns {string}
   */
  function selectedOptionValues(link) {
    const scope = link.closest('.shopify-section') || document;
    const picker = scope.querySelector('variant-picker') || document.querySelector('variant-picker');
    if (!picker) return '';

    return Array.from(picker.querySelectorAll('input[type="radio"]:checked, select'))
      .map((field) => /** @type {HTMLInputElement | HTMLSelectElement} */ (field).value)
      .filter(Boolean)
      .join(' / ');
  }

  /**
   * @param {HTMLElement} link
   * @returns {string}
   */
  function buildMessage(link) {
    const { prefillMessage, prefillBase, prefillVariantLabel } = link.dataset;
    if (!prefillBase || !prefillVariantLabel) return prefillMessage || '';

    const values = selectedOptionValues(link);
    return values ? prefillBase + prefillVariantLabel + values : prefillMessage || prefillBase;
  }

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const link = /** @type {HTMLElement | null} */ (target.closest('[data-inquire-link]'));
    if (!link) return;

    const message = buildMessage(link);
    if (!message) return;

    /** @type {{ message: string, ts: number, customerType?: string }} */
    const payload = { message, ts: Date.now() };
    if (link.dataset.prefillCustomerType) {
      payload.customerType = link.dataset.prefillCustomerType;
    }

    try {
      // `ts` lässt contact-tabs.js eine nie abgeholte Nachricht verfallen — das
      // Linkziel ist im Editor frei setzbar und muss die Section nicht enthalten.
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    } catch (_) {
      // sessionStorage nicht verfügbar (privater Modus, Quota) — die Kontaktseite
      // öffnet dann einfach mit leerem Formular.
    }
  });
})();
